(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-ingredient-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ls-ingredient-rail')) {
    customElements.define('ls-ingredient-rail', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          const left = this.getBoundingClientRect().left;
          const base = this.parentElement.clientWidth;
          this.style.setProperty('--rail-base-width', base + 'px');
          this.style.setProperty('--rail-bleed', Math.max(0, document.documentElement.clientWidth - left - base) + 'px');
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.parentElement);
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
